import React from 'react';
import PropTypes from 'prop-types';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import Circle from 'lucide-react/dist/esm/icons/circle';
import { cn } from '~/lib/utils';

const RadioGroup = React.forwardRef(({ className, ...props }, ref) => (
	<RadioGroupPrimitive.Root ref={ref} className={cn('grid gap-3', className)} {...props} />
));

RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
RadioGroup.propTypes = {
	className: PropTypes.string
};

const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => (
	<RadioGroupPrimitive.Item
		ref={ref}
		className={cn('aspect-square h-4 w-4 rounded-full border border-input text-primary shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-transparent disabled:cursor-not-allowed disabled:opacity-50', className)}
		{...props}
	>
		<RadioGroupPrimitive.Indicator className="flex items-center justify-center">
			<Circle className="h-2.5 w-2.5 fill-current text-current" />
		</RadioGroupPrimitive.Indicator>
	</RadioGroupPrimitive.Item>
));

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
RadioGroupItem.propTypes = {
	className: PropTypes.string
};

export { RadioGroup, RadioGroupItem };
